/*
 ###################
 ## JointHolders ##
 ##################
Allow to add dinamic fileds for joint holders.
Mucho de los states deben ser reemplazados por las props de react-redux-form.
userProfile.jointHolderEditable indica si la cajita está colapsada o expandida.
userProfile.jointHolderIsEditing indica si se está editando un form que ya fué añadido.

 * OPTIONS
 * profileModel [String]: Model of data. Required.
 * limit [Integer]: Max of fields allowed.
 * initial [Integer]: Cajitas en pantalla por defecto.

 * EXAMPLE
     <JointHolders
     initial={1}
     limit={this.state.jointHolderLimit}
     />
 */
//@ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const formActions = require('react-redux-form').actions;
const { animateScroll } = require('react-scroll');
//@ components
const Detail = require('./detail').Detail;
const CheckBox = require('components/checkBox/checkBox');
//@utilities
import { FormattedText, formatText } from 'core/i18n';

class JointHolders extends React.Component {
    constructor(props) {
        super(props);
        this.buildBoxes = this.buildBoxes.bind(this);
        this.handleOnClick = this.handleOnClick.bind(this);
        this.buildAddLink = this.buildAddLink.bind(this);
        this.handleOnCloseDisclaimer = this.handleOnCloseDisclaimer.bind(this);
        this.handleOnRef = this.handleOnRef.bind(this);
        this.builCheckBoxLegal = this.builCheckBoxLegal.bind(this);

        this.state = {
            showDisclaimerLimit: true,
        };

        this.blockElements = [];
    }

    UNSAFE_componentWillMount() {
        const { userProfile, formActions } = this.props;

        formActions.change('userProfile.jointHoldersError', false);

        if (!userProfile.jointHolderCount && userProfile.status !== 'waiting') {
            formActions.push('userProfile.jointHolderCount', 1); // Create an array
        }

        if (typeof userProfile.jointHolderEditable === 'undefined') {
            formActions.change('userProfile.jointHolderEditable', 1);
        }

        if (!userProfile.jointHolderCount && userProfile.status === 'waiting') {
            formActions.change('userProfile.jointHolderCount', []); // Create an array
            formActions.change('userProfile.jointHolderEditable', false);
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.userProfile.jointHolderCount !== this.props.userProfile.jointHolderCount &&
            this.blockElements.length > 1
        ) {
            const lastElement = this.blockElements[this.blockElements.length - 1];
            if (lastElement) {
                const bodyRect = document.body.getBoundingClientRect();
                const elementRect = lastElement.getBoundingClientRect();
                const offset = elementRect.top - bodyRect.top - 90;
                animateScroll.scrollTo(offset, { duration: 500 });
            }
        }
    }

    componentWillUnmount() {
        const { formActions, userProfile } = this.props;
        const disabled = this.props.immStepsState.get('readOnlyForms');
        const count = userProfile['jointHolderCount'] ? userProfile['jointHolderCount'].length : 0;

        if (!disabled) {
            for (let id = 1; id < count + 1; id++) {
                formActions.setValidity('userProfile.jointholder_' + id + '_name', { required: true });
                formActions.setValidity('userProfile.jointholder_' + id + '_lastName', { required: true });
                formActions.setValidity('userProfile.jointholder_' + id + '_secondLastName', { required: true });
                formActions.setValidity('userProfile.jointholder_' + id + '_documentType', { required: true });
                formActions.setValidity('userProfile.jointholder_' + id + '_docNumber', { required: true });
                formActions.setValidity('userProfile.jointholder_' + id + '_accountType', { required: true });
                formActions.setValidity('userProfile.jointholder_' + id + '_email', { required: true });
            }

            formActions.change('userProfile.jointHoldersError', false);
            formActions.setValidity('userProfile.jointHolderAuthorizedList', { required: true });
        }
    }

    handleOnRef(element) {
        this.blockElements.push(element);
    }

    handleOnClick() {
        const { userProfile, formActions, limit } = this.props;
        formActions.setValidity('userProfile.jointHolderAuthorizedList', { required: true });
        const num = Object.keys(userProfile.jointHolderCount).length;

        if (limit && num < limit) {
            const preIndex = parseInt(userProfile.jointHolderCount[num - 1]) + 1;
            const index = isNaN(preIndex) ? 1 : preIndex;
            formActions.push('userProfile.jointHolderCount', index);
            formActions.change('userProfile.jointHolderEditable', index);
            formActions.change('userProfile.jointHoldersError', false);
        }

        this.setState({
            showDisclaimerLimit: true,
        });
    }

    handleOnCloseDisclaimer() {
        this.setState({
            showDisclaimerLimit: false,
        });
    }

    buildBoxes() {
        const { userProfile } = this.props;
        const boxes = [],
            count = userProfile.jointHolderCount ? Object.keys(userProfile.jointHolderCount).length : 0;

        for (let i = 0; i < count; i++) {
            boxes[i] = (
                <div ref={this.handleOnRef} key={'key_' + userProfile.jointHolderCount[i] + '_' + i}>
                    <Detail id={userProfile.jointHolderCount[i]} position={i} />
                </div>
            );
        }

        if (count === 0 && userProfile.status === 'waiting') {
            return this.buildNoHoldersBlock();
        }

        return boxes;
    }

    buildNoHoldersBlock() {
        return (
            <div className="no-holders">
                <div className="icon-container">
                    <i className="icons icons--icon-no-holders"></i>
                </div>
                <div className="text-container">
                    <FormattedText value="initial-removeAllHolders" />
                </div>
            </div>
        );
    }

    buildAddLink() {
        const { userProfile, limit } = this.props;
        const count = userProfile.jointHolderCount ? Object.keys(userProfile.jointHolderCount).length : 0;
        const addMore = limit - count;

        return (
            <div className="row inner-form__add-link-hc">
                <div className="col-md-6 col-sm-6 col-xs-12">
                    <button
                        disabled={userProfile.jointHolderEditable}
                        type="button"
                        className="form__button form__button-primary add-button"
                        onClick={this.handleOnClick}
                    >
                        <i className="icons icons--icon-add-blue"></i>
                        <FormattedText value="initial-jointHolderAdd" />
                    </button>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12 inner-form__joint-holder-count">
                    <p className="joint-holder-quantity">
                        <FormattedText value="initial-jointHolderAddMore" injectedStrings={[addMore]} />
                    </p>
                </div>
            </div>
        );
    }

    builCheckBoxLegal(allJointHolderNames) {
        const { userProfile, userProfileForm, formActions } = this.props;
        return (
            <div>
                <div className="joint-holder__disclaimer"></div>
                <div className="check-box__legal">
                    <CheckBox
                        className="field_acceptClausule"
                        profileModel={'userProfile.jointHolderAuthorizedList'}
                        fieldsRequired="1"
                        checkBoxList={[
                            {
                                label: (
                                    <FormattedText
                                        value="field-gdprJointHolderClause"
                                        injectedStrings={[allJointHolderNames]}
                                    />
                                ),
                                model: 'userProfile.jointHolderAuthorizedList_option',
                            },
                        ]}
                        disabled={userProfile.jointHolderInvited}
                        userProfile={userProfile}
                        userProfileForm={userProfileForm}
                        formActions={formActions}
                        remarkable={true}
                        messagesError={{ required: formatText('field-jointHolderClausuleError') }}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { userProfile, limit, immJointHoldersStatus } = this.props;
        const allJointHolder = userProfile.jointHolderCount ? Object.keys(userProfile.jointHolderCount).length : 0;
        let addJointHolder = userProfile.jointHolderCount && allJointHolder < limit;
        addJointHolder =
            userProfile.jointHolderInvited &&
            !(immJointHoldersStatus.get('fetchSuccess') || userProfile.status === 'waiting')
                ? false
                : addJointHolder;
        let allJointHolderNames = '';
        userProfile['jointHolderCount']
            ? userProfile['jointHolderCount'].map((val, index) => {
                  if (
                      userProfile['jointHolderCount'].length > 1 &&
                      userProfile['jointHolderCount'].length - 1 === index
                  ) {
                      allJointHolderNames = allJointHolderNames.substring(0, allJointHolderNames.length - 2) + ' y ';
                  }
                  allJointHolderNames += ` ${userProfile[`jointholder_${val}_name`]} ${
                      userProfile[`jointholder_${val}_lastName`]
                  } ${
                      userProfile[`jointholder_${val}_secondLastName`]
                          ? userProfile[`jointholder_${val}_secondLastName`]
                          : ''
                  }, `;
              })
            : null;
        allJointHolderNames = allJointHolderNames.substring(0, allJointHolderNames.length - 2);
        const showDisclaimer =
            !userProfile['jointHolderEditable'] &&
            allJointHolder >= 1 &&
            !(immJointHoldersStatus.get('fetchSuccess') || userProfile.status === 'waiting')
                ? this.builCheckBoxLegal(allJointHolderNames)
                : null;

        return (
            <div className="jointholders">
                <div className="box-container">{this.buildBoxes()}</div>
                {addJointHolder ? this.buildAddLink() : null}
                {allJointHolder >= 4 && !userProfile['jointHolderEditable'] ? (
                    <div
                        className={
                            'form__address-autocomplete__disclaimer ' +
                            (!this.state.showDisclaimerLimit ? 'hidden' : '')
                        }
                    >
                        <p className="font-paragraph2">
                            <i className="icons icons--icon-warning-2"></i>{' '}
                            <div className="joint-holder-limit">
                                <FormattedText value="field-jointHolderLimit" />
                            </div>{' '}
                            <a
                                href="#"
                                onClick={event => {
                                    event.preventDefault();
                                    this.handleOnCloseDisclaimer();
                                }}
                            >
                                <i className="icons icons--icon-close"></i>
                            </a>
                        </p>
                    </div>
                ) : (
                    ''
                )}
                <div>{showDisclaimer}</div>
            </div>
        );
    }
}

JointHolders.proptypes = {
    initial: PropTypes.integer,
    limit: PropTypes.integer,
};

JointHolders.defaultProps = {
    initial: 1,
    limit: 4,
};

module.exports.JointHolders = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        immJointHoldersStatus: state.jointHoldersStatus,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
    })
)(JointHolders);
